import { JustificativaFieldView } from "./view-justificativa-field";
import type { JustificativaFieldProps } from "./types-justificativa-field";

export function JustificativaField(props: JustificativaFieldProps) {
  return <JustificativaFieldView {...props} />;
}

export {
  JUSTIFICATIVA_LABEL,
  JUSTIFICATIVA_MAX,
  JUSTIFICATIVA_OBRIGATORIA,
} from "./justificativa-field.constants";
export type * from "./types-justificativa-field";
